import React from "react";
import { Card, Table, Text } from "@wix/design-system";
import { ProductDetailColumn, IWixProduct } from "../../../../services/models/types/wixProduct.types";

const detailsColumns: ProductDetailColumn[] = [
  {
    title: "Variant",
    render: (variant) => <Text size="small">{variant?.variantName}</Text>,
  },
  {
    title: "SKU",
    render: (variant) => <Text size="small">{variant?.sku}</Text>,
  },
  {
    title: "Price",
    render: (variant) => (
      <Text size="small">
        {variant?.currency} {variant?.price}
      </Text>
    ),
  },
  {
    title: "Inventory",
    render: (variant) => {
      const stockStatus = variant?.inStock ? "In Stock" : "Out of stock";
      return <Text size="small">{variant?.trackQuantity ? variant?.quantity : stockStatus}</Text>;
    },
  },
];

interface WixProductRowDetailProps {
  product: IWixProduct;
}

const WixProductRowDetail: React.FC<WixProductRowDetailProps> = ({ product }) => {
  if (!product.manageVariants) return <></>;

  return (
    <Card showShadow hideOverflow>
      <Table skin="neutral" isRowHighlight={() => true} data={product?.variants} columns={detailsColumns}>
        <Table.Content />
      </Table>
    </Card>
  );
};

export default WixProductRowDetail;
